import { Option } from 'shared/components/Select/models/Option';
import { coworkingAccessLabelMap } from 'shared/constants/filters/advanced/coworkingAccess';
import { ECoworkingAccess } from 'shared/types/filters/advanced/coworkingAccess';

export const coworkingAccessOptions = [
  new Option(ECoworkingAccess.AllDayAccess, coworkingAccessLabelMap[ECoworkingAccess.AllDayAccess]),
  new Option(ECoworkingAccess.AllWeekAccess, coworkingAccessLabelMap[ECoworkingAccess.AllWeekAccess]),
];
